import React, { useContext } from 'react';
import './LatestCheckIn.css';
import ModuleLoadingStatus from '../ModuleLoadingStatus/ModuleLoadingStatus';
import { CardLatestCheckInContext } from '../../contexts/CardLatestCheckInContext';
import logComponent from '../../common/logComponent';

export default function LatestCheckInLoadingStatus({ reloadAction }) {
  const cardLatestCheckInContext = useContext(CardLatestCheckInContext);
  const { latestCheckInLoading, latestCheckInError } = cardLatestCheckInContext;

  if (logComponent('LatestCheckInLoadingStatus')) { console.debug('LatestCheckInLoadingStatus rendered'); }


  return (
    <ModuleLoadingStatus isLoading={latestCheckInLoading} isError={latestCheckInError} reloadAction={reloadAction} />
  );
}